import React, { useContext } from 'react';
import { FormTextField, usePrompts } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';
import { PlannerContext } from '../planner-context';
import { UnitMenuProps } from './unit-menu';

export const useEditUnitCallFirstDialog = (unit: UnitMenuProps['unit']) => {
  const { calendarSource } = useContext(PlannerContext);

  usePrompts(
    [
      {
        key: `UNIT_EDIT_CALL_FIRST_DIALOG_${unit.id}`,
        dialogTitle: `Volať ako prvého - jednotka ${unit.name}`,
        FormFields: () => (
          <FormTextField name="callFirst" label="Volať ako prvého" />
        ),
        dialogText: '',
        dialogWidth: 1000,
        dialogShowClose: true,
        dialogShowConfirm: true,
        formInitialValues: {
          callFirst: unit.callFirst ?? '',
        },
      },
    ],
    [unit.id]
  );
  return {
    unitEditCallFirstDialogKey: `UNIT_EDIT_CALL_FIRST_DIALOG_${unit.id}`,
    onEditCallFirstSubmit: async (values: { callFirst: string }) => {
      const response = await fetch(`${EvidenceApiUrl.MOBILE_UNITS}/${unit.id}`);
      if (!response.ok) {
        return;
      }
      const data = await response.json();

      await fetch(`${EvidenceApiUrl.MOBILE_UNITS}/${unit.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          callFirst: values.callFirst,
        }),
      });
      calendarSource?.yAxis?.refreshData?.();
    },
  };
};
